// Exports
// -------

// Polyfilled `requestAnimationFrame` for more performant animation:
// https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
//
// Usage:
//  ```javascript
//  import requestAnimationFrame from 'path/to/requestAnimationFrame';
//  requestAnimationFrame(doSomethingNifty);
//  ```
export default (function () {
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };
})();
